import { useState, useEffect } from 'react';
import TablaUsuario from "../components/TablaUsuario";
import { message } from 'antd';
import axios from "./../../../services/http";

const ListadoUsuarioLayout = ({ reloadData, EditUser }) => {

    const [users, setUsers] =useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        GetUsers();
    }, [reloadData]);

    const GetUsers = async () => {
        try {
            setLoading(true);
            const response = await axios.HTTP_GET("/api/usuarios");
            setUsers(response);
        } catch (e) {
            console.error('Error al obtener los usuarios:', e);
            message.error('Error al obtener los usuarios');
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            {/* Aqui van los filtros */}

            <TablaUsuario
                data={users}
                loading={loading}
                setLoading={setLoading}
                GetUsers={GetUsers}
                EditUser={EditUser}
            />
        </>
    )
}

export default ListadoUsuarioLayout;